// Chat-style feed behaviour from an installed engine RelatedEntityFeed (row-component-conditions,
// last-seen-separator-component, anchor-to-bottom), kept pure so the feed element and its tests share it.

export function conditionComponentId(conditions, scope, evaluate, reportError = message => console.error(message)) { // eslint-disable-line no-console
  const list = Array.isArray(conditions) ? conditions : [];
  for (let index = 0; index < list.length; index++) {
    const condition = list[index];
    try {
      if (evaluate(condition.visibilityExpression, scope)) {
        return Number(condition.componentId) || 0;
      }
    } catch (error) {
      reportError(`feed-row-conditions[${index}] could not be evaluated, so its component is skipped: ${error.message}`);
    }
  }
  return 0;
}

// Same rule as the engine: above the flagged row, never after the final row.
export function rowsWithLastSeen(rows, componentId) {
  if (!(componentId > 0)) {
    return rows;
  }
  const out = [];
  rows.forEach((row, index) => {
    const isLast = index === rows.length - 1;
    if (row.kind === "row" && row.entity?.isLastSeen && !isLast) {
      out.push({ kind: "section", key: "last-seen", componentId, label: "", readPosition: true });
    }
    out.push(row);
  });
  return out;
}

export function anchoredOrder(rows, anchored) {
  return anchored ? [...rows].reverse() : rows;
}
